import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from '@openng/optimus-ui/toast';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';
import { LoaderService } from './services/loader.service';
import { FullLoader } from './data/loading-keys';
import { APP_VERSION } from './data/version';
import { FloatingChatComponent } from './components/floating-chat/floating-chat';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    FloatingChatComponent,
  ],
  template: `
    <p-toast />
    <p-confirm-dialog />
    <router-outlet />
    <app-floating-chat />
    @if (isResolving()) {
      <div
        class="fixed inset-0 z-50 flex flex-col items-center justify-center bg-surface-0/80 backdrop-blur-sm">
        <p-progress-spinner strokeWidth="4" />
        <span class="mt-4 text-sm text-surface-500">Loading...</span>
      </div>
    }
    <img
      src="images/clarita-blue-new2.png"
      alt="Clarita"
      class="fixed bottom-0 right-0 pointer-events-none select-none opacity-20 -z-10"
      style="max-height: 33vh; width: auto;" />
    <span class="fixed bottom-2 right-3 text-xs text-surface-300 select-none">{{ version }}</span>
  `,
})
export class App {
  protected readonly isResolving = inject(LoaderService).isLoading(FullLoader);
  protected readonly version = APP_VERSION;
}
